var DEFAULT_BATCH_SIZE = 20;

class ChatScreenController {
    constructor() {

        this.INDIVIDUAL_ROOM = 1;
        this.GROUP_ROOM = 2;
        this.CANAL_ROOM = 3;
        this.SUPPORT_ROOM = 4;

        this.TEXT_MESSAGE_TYPE = 1;
        this.PROJECT_DOCUMENT_TYPE = 2;
        this.USER_DOCUMENT_TYPE = 3;

        this.MESSAGES_ROOM_OPTION = 'messages';
        this.USER_PROFILE_ROOM_OPTION = 'userProfile';
        this.GROUP_PROFILE_ROOM_OPTION = 'groupProfile';
        this.CHALLENGE_ROOM_OPTION = 'challenge';

        this.tabs = new Tabs();
        this.chat = new Chat(); // Se usara como modelo del chat para la construccion de elementos del chat (mensajes, salas...)
        this.chatUploadDocument = new ChatUploadDocument();
        this.slideActionsFriendList = new SlideActionsFriendList();
        this.openedProjectDocumentMessage = null;
        this.modalShareChatDocument = documentationScreenController.documentationShareChat;
        this.projectDocumentDetailsOpen = false;
        this.room = {}; // Sala actual en la que se encuentra el usuario
        this.sendProjectDocumentRoomData = {};
        this.sendedProjectDocumentRooms = {};
        this.sendedProjectDocuments = {};
        this.rooms = [];    // Salas visibles en un momento determinado, creadas o no. (Lista de todas las salas, de un tipo, busquedas...)
        this.resMessages = [];
        this.inChatRoom = false;
        this.roomSelectedOption = null; // Opcion seleccionada dentro de la sala de chat (por defecto la de los mensajes)
        this.assistantView = false;

        this.allRooms = {rooms: [], roomsIds: []};  // Todas las salas creadas, los roomsIds es para acceder mas rapido con indexOf y no tener que buscarlas
        this.individualRooms = {rooms: [], roomsIds: []};
        this.groupRooms = {rooms: [], roomsIds: []};
        this.canalRooms = {rooms: [], roomsIds: []};
        this.supportRooms = {rooms: [], roomsIds: []};

        this.loadPartialsTemplates();

        DEFAULT_BATCH_SIZE = Math.ceil(($(window).height() - $('#appHeader').outerHeight()) / 50);  // Para asegurarnos de que siempre haya scroll
    }

    loadPartialsTemplates() {
        Handlebars.registerPartial("roomHeaderFragment", $("#roomHeaderFragment").html());
        Handlebars.registerPartial("chatListSupportCanvasFragment", $('#chatListSupportCanvasFragment').html());
        Handlebars.registerPartial("roomHeaderButtonsFragment", $('#roomHeaderButtonsFragment').html());
    }

    drawChatList(rooms, isSearchResult=false){

        let tabs = new Tabs();
        rooms = _.sortBy(rooms, [function (room) {
            return room.last_message ? -room.last_message.send_date : 0;
        }]);

        let that = this;
        this.rooms = rooms;

        function drawList() {

            if (!that.modalShareChatDocument.modalOpen) {
                baseController.resetStackableOrder();
                baseController.drawMainMenu(that.tabs.CHAT_TAB);
            }

            that.rooms.forEach(function (room) {
                if (room.type === that.GROUP_ROOM && room.last_message) {
                    let user = room.users.filter(function (user) {
                        return user.id === room.last_message.user_id;
                    })[0];
                    // Es posible que el ultimo mensaje fuera de un usuario que ya no esta en la sala y por ende no se encuentre en la lista de users de la sala
                    // En este caso no podemos obtener el username del usuario que envio el ultimo mensaje
                    if (user) {
                        room.last_message.username = user.username;
                    }
                }
            });

            let chatListTemplate = Handlebars.compile($("#worldChatListScreen").html());
            let chatListContext = that.chat.getChatListData(rooms, isSearchResult);

            if (that.modalShareChatDocument.modalOpen) {

                $('.uploadGroupScrollable').find('#chatSection').remove();

                let modalBody = $('.documentationStackable').last();

                if (modalBody.length === 0) {
                    modalBody = $(".documentationSectionStackable").last();
                }

                _.forEach(that.allRooms.rooms, function(room) {
                    if (that.sendedProjectDocumentRooms[room.id]) {
                        room.projectDocumentSended = true;
                    } else {
                        room.projectDocumentSended = false;
                    }
                });

                modalBody.find(".uploadGroupScrollable").append(chatListTemplate(chatListContext));

                let modalBodyChatSection = $('.uploadGroupScrollable').find('#chatSection');
                let modalHeaderHeight = $('.uploadContentTopArea').last().css('height');

                modalBodyChatSection.css('padding-top', modalHeaderHeight);

                setTimeout(function() {
                    $(".friend-item.is-chat .last-message").dotdotdot({
                        height: 35,
                        wrap: 'letter',
                        watch: true,
                    });
                }, 0);

            } else {

                const userWorldIds = _.uniq(_.map(that.individualRooms.rooms, 'user.user_world_id')).join(';');

                api.getUsersDirectory(userWorldIds, function(directoryResponse) {
                    _.forEach(chatListContext.rooms, function(chatItem) {

                        if (chatItem.type === that.INDIVIDUAL_ROOM) {

                            const directoryData = _.find(directoryResponse.result.users, function(user) {
                                return parseInt(chatItem.user.user_world_id) === parseInt(user.user_world_id);
                            });

                            if (directoryData) {
                                that.chat.setDirectoryData(chatItem, directoryData);
                            }

                        }

                    });
                    $("#jugar").html(chatListTemplate(chatListContext));
                    that.slideActionsFriendList.initialize();

                    if (isSearchResult) {
                        $('.chat-search-back-btn').show();
                        $('.friends-search-bar-icon').addClass('search-chat');
                        $('.friends-search-bar-input').addClass('search-chat');
                        $(document).off('click.exitSearch').on('click.exitSearch', '.chat-search-back-btn', function () {
                            api.getChats(function (roomsResponse) {
                                api.getUnreadMessages(roomsResponse.rooms);
                                that.drawChatUnreadMessages();
                                that.saveRooms(roomsResponse.rooms, true);
                                let supportRooms = that.supportRooms.rooms;
                                let otherRooms = that.individualRooms.rooms.concat(that.groupRooms.rooms, that.canalRooms.rooms);
                                let roomsToShow = that.assistantView ? supportRooms : otherRooms;
                                that.drawChatList(roomsToShow, false);
                            });
                        });
                    }

                    setTimeout(function() {
                        $(".friend-item.is-chat .last-message").dotdotdot({
                            height: 35,
                            wrap: 'letter',
                            watch: true,
                        });
                    }, 0);

                });

            }

            $(window).off('resize.resizerNoMessagesBack');

            if (!rooms || !rooms.length) {

                if (!that.modalShareChatDocument.modalOpen) {
                    $('.no-chats-list').height(
                        $('.quiz-wrapper').height() - $('header').height() - $('.friends-search-bar').outerHeight()
                    );

                    $(window).on('resize.resizerNoMessagesBack', function () {
                        $('.no-chats-list').height(
                            $('.quiz-wrapper').height() - $('header').height() - $('.friends-search-bar').outerHeight()
                        );
                    });
                } else {

                    let maxModalHeight = parseInt($('.uploadGroup.displayedUpload').css('max-height'));
                    let modalHeight = _.min([$(window).height() * documentationScreenController.documentationShareChat.modalAnimationHeight, maxModalHeight]);
                    let modalHeaderHeight = parseInt($('.uploadContentTopArea').css('height'));
                    let modalSearchFriendsHeight = parseInt($('.friends-search-bar').css('height'));
                    let noChatListHeight = modalHeight - modalHeaderHeight - modalSearchFriendsHeight;

                    $('.no-chats-list').css('height', noChatListHeight + 'px')

                }

            }

            if (!that.modalShareChatDocument.modalOpen) {
                // Colocar el color de fondo por defecto en la pantalla del listado de chats
                $('.quiz-wrapper').attr('class', 'quiz-wrapper');
            }

            $(".chatChevronCanvas").each(function () {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
            });

            $('.shareToChatButton').each(function() {
                tintImage($(this).attr('id'), customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE_CHAT"], '000000')
            });

            $(document).off('click.chatRoomCanvas').on('click.chatRoomCanvas', '.friend-item.is-chat', function (event) {

                event.preventDefault();
                event.stopPropagation();

                if (that.modalShareChatDocument.modalOpen) {

                    let room = rooms[$(this).data('room')];

                    if (!room.projectDocumentSended) {
                        let messagePayload = that.modalShareChatDocument.documentId;
                        let messageType = that.PROJECT_DOCUMENT_TYPE;
                        let messageRoomId = room.id;
                        let messageUserId = room.type === that.INDIVIDUAL_ROOM || room.type === that.SUPPORT_ROOM ? room.user.user_world_id : null;
                        let messageToSupport = false;
                        that.sendProjectDocumentRoomData = room;
                        socketRequest.sendMessage(messagePayload, messageType, messageRoomId, messageUserId, messageToSupport);
                    }
                } else {
                    $(this).attr("data-active", true);
                    worldHomeController.friends = rooms[$(this).data('room')].users;
                    that.drawIndividualChat(rooms[$(this).data('room')]);
                }
            });

            $(document).off('click.searchFriends').on('click.searchFriends', '.chat-friends-search-bar-btn', function () {
                var inputValue = $('.friends-search-bar-input').last().val();

                if (inputValue.length) {
                    api.getChatFriends(world.token, inputValue, that.assistantView, function (friends) {
                        that.drawChatSearchList(friends);
                        rankingScreenController.adaptDivToContentRankingUsersList();
                    });
                }
            });

            if (isSearchResult) {
                $('.chat-search-back-btn').show();
                $('.friends-search-bar-icon').addClass('search-chat');
                $('.friends-search-bar-input').addClass('search-chat');
                $(document).off('click.exitSearch').on('click.exitSearch', '.chat-search-back-btn', function () {
                    api.getChats(function (roomsResponse) {
                        api.getUnreadMessages(roomsResponse.rooms);
                        that.drawChatUnreadMessages();
                        that.saveRooms(roomsResponse.rooms, true);
                        let supportRooms = that.supportRooms.rooms;
                        let otherRooms = that.individualRooms.rooms.concat(that.groupRooms.rooms, that.canalRooms.rooms);
                        let roomsToShow = that.assistantView ? supportRooms : otherRooms;
                        that.drawChatList(roomsToShow, false);
                    });
                });
            }
        }
        drawList();

        if (world.chat_support_enabled) {
            this.supportChatManagement();
        }
    }

    drawChatSearchList(friends){

        let that = this;
        let searchRooms = [];
        let createdRooms = this.assistantView ? this.supportRooms.rooms : this.individualRooms.rooms;
        let createdRoomsWorldIds = _.map(createdRooms, function(createdRoom) {
            return createdRoom.user.user_world_id;
        });
        let newEmptyRoomType = this.assistantView ? this.SUPPORT_ROOM : this.INDIVIDUAL_ROOM;

        _.forEach(friends, function(friend) {
            let createdRoomIndex = createdRoomsWorldIds.indexOf(friend.user_world_id);
            createdRoomIndex >= 0 ? searchRooms.push(createdRooms[createdRoomIndex]) : searchRooms.push(that.chat.getNewEmptyRoom(friend, newEmptyRoomType));
        });

        this.drawChatList(searchRooms, true);
    }

    drawIndividualChat(room, callback = null){
        var that = this;
        this.room = room;

        function drawChatRoom(resMessages=null){
            $('.chatMessages').remove();

            let chatMessageTemplate = Handlebars.compile($("#worldChatMessageScreen").html());
            let messageDates = null;

            that.inChatRoom = true;
            that.roomSelectedOption = that.MESSAGES_ROOM_OPTION;
            that.resMessages = [];

            if (that.room.id) {
                socketRequest.changeRoomStatus(that.inChatRoom, that.room.id);
            }

            if(resMessages){
                that.resMessages = resMessages;
                that.resMessages.sort(that.sortAscMessages);
                messageDates = that.formatMessages(resMessages, that.room.users);
            }

            let firstDayYearTimestamp = Math.floor(new Date(new Date().getFullYear(), 0, 1).getTime() / 1000);
            let lastMessageUser = null;

            if (that.room.last_message) {
                lastMessageUser = that.getUserMessage(that.room.users, that.room.last_message.user_id);
            }

            baseController.stackSimpleContent(chatMessageTemplate, {
                'roomHeaderData': that.chat.getRoomHeaderData(that.room),
                'messageDates': messageDates,
                'firstDayYearTimestamp': firstDayYearTimestamp,
                'userworldId': user.user_world_id,
                'unreadMsg': that.room.total_unread_messages,
                'firstMsgNotRead': that.room.user_pointer + 1,
                'otherUserLastRead': that.room.other_user_pointer,
                'lastSendMessageDate': that.resMessages.length ? that.resMessages[that.resMessages.length -1].send_date : null,
                'lastSendMessageUserWorld': that.resMessages.length ? that.resMessages[that.resMessages.length -1].user_world_id : null,
                'lastSendMessageUsername': lastMessageUser ? lastMessageUser.username : null,
                'lastSendMessageUserIcon': lastMessageUser ? lastMessageUser.icon : null,
                'roomLastMessage': that.room.last_message,
                'type': that.room.type,
                'defaultUserIcon': world.theme.user_icon,
                'write_enabled': that.room.write_enabled,
                'noPermissionsDocumentIcon': customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"]
            }, 'CHAT');

            if(that.room.total_unread_messages > 0){
                that.updateChatNotifications('DEDUCT', null, that.room.type, that.room.total_unread_messages);
            }

            that.room.user_pointer = that.room.last_message ? that.room.last_message.id : null;
            that.room.total_unread_messages = 0;

            let individualOrSupportRoom = that.room.type === that.INDIVIDUAL_ROOM || that.room.type === that.SUPPORT_ROOM;
            let backChevron = $("#chat-back-chevron");
            let sendChallengeBtn = $('#chatButtonSendChallengeMsg');
            let sendMessageBtn = $('#chat-send-message-icon')
            let sendDocumentBtn = $('#chat-send-document-icon');
            let doctypeName = $('.message-user-document-doc-name');
            let projectDocumentName = $('.project-document-message-name');

            tintImage(backChevron.attr('id'), backChevron.attr('data-icon'), backChevron.attr('data-color'));
            tintImage(sendChallengeBtn.attr('id'), sendChallengeBtn.attr('data-icon'), sendChallengeBtn.attr('data-color'));
            tintImage(sendMessageBtn.attr('id'), sendMessageBtn.attr('data-icon'), '000000');
            tintImage(sendDocumentBtn.attr('id'), sendDocumentBtn.attr('data-icon'), '60605f');

            $('.chat-button-canvas').each(function() {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), individualOrSupportRoom ? world.theme.login_text_color : 'FFFFFF');
            });

            $('.tintedCanvas.doctype-icon').each(function() {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), '000000');
            });

            $('.tintedCanvas.project-document-icon').each(function() {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), '000000');
            });

            let documentNameHeight = 30;

            if ($(window).width() <= 420) {
                documentNameHeight = 20;
            }

            doctypeName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true,
            });

            projectDocumentName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true
            });

            let quizWrapper = $('.quiz-wrapper');
            quizWrapper.addClass('chat-messages-wrapper');

            let chatMessages = $('#chat-messages');

            // chatMessages.niceScroll(getNiceScrollStyle());

            let challengeButton = $(".chat-button-challenge");
            let messagesButton = $(".chat-button-comments");
            let profileButton = $(".chat-button-profile");
            let profileButtonGroup = $(".chat-button-profile-group");
            let msgContentArea = $('#chat-messages-content-area');
            let notReadMsgBar = $(".not-read-chat-messages-label");
            let focusedComment = false;
            let chatTextarea = $("#chatCommentTextarea");
            let currentTextareaHeight = chatTextarea.outerHeight();
            let lastScrollPos = 2;
            let loadMorePrevComments = true;

            $('.friend-item.is-chat[data-active="true"]').find('.chat-list-not-read-messages').remove();
            $('.friend-item.is-chat[data-active="true"]').find('.chat-list-last-message-date').removeClass('world_color_1');

            setTimeout(ChatScreenController.adjustChatHeight, 50);

            $(window).resize(() => {
                setTimeout(ChatScreenController.adjustChatHeight, 50);
            });

            $(document).off('click.exitChatRoom').on('click.exitChatRoom', '.top-chat-info-back-btn', function() {
                const tabs = new Tabs();

                if (msgContentArea.is(':visible')) {
                    that.inChatRoom = false;
                    that.roomSelectedOption = null;

                    if (that.room.id) {
                        socketRequest.changeRoomStatus(that.inChatRoom, that.room.id);
                    }
                    quizWrapper.removeClass('chat-messages-wrapper');
                }

                if (baseController.selectedTabId === that.tabs.CHAT_TAB) {
                    that.room = {};
                    let backBtn = $('.chat-search-back-btn');
                    that.drawChatList(that.rooms, (backBtn.length && backBtn.css('display') === 'block'));
                } else {
                    baseController.closeStack();
                }
                rankingScreenController.adaptDivToContentRankingUsersList();
                friendsScreenController.hasToRemoveChatProfileStack = false;
            });

            $(document).off('click.initUploadSection').on('click.initUploadSection', '.chat-send-document-action-icon', function() {
                that.chatUploadDocument.initUploadSection();
            });


            //Text area events
            $(document).off('click.sendNewMessage').on('click.sendNewMessage', '#chatCommentTextarea', function() {
                if (!focusedComment) {
                    focusedComment = true;

                    // Evento para el envio del mensaje con la tecla ENTER
                    $(document).off('keypress').on('keypress', '#chatCommentTextarea', function(e) {
                        if(e.which === 13 && !e.shiftKey){
                            e.preventDefault();
                            e.stopPropagation();

                            let newMessage = chatTextarea.val().trim();
                            let roomId = that.room.id;
                            let userworldId = that.room.user ? that.room.user.user_world_id : null;
                            let isSupport = that.room.type === that.SUPPORT_ROOM;

                            if(newMessage && newMessage.length > 0){
                                chatTextarea.val('');
                                socketRequest.sendMessage(newMessage, that.TEXT_MESSAGE_TYPE, roomId, userworldId, isSupport);
                            }
                        }
                    });

                    // Evento para el estilo del icono de enviar mensajes segun si hay texto o no
                    $(document).off('keyup').on('keyup', '#chatCommentTextarea', function() {

                        let newMessage = chatTextarea.val().trim();
                        let iconColor = world.theme.login_text_color;
                        let backgroundColor = world.theme.color_1;

                        if (that.room.type === that.GROUP_ROOM || that.room.type === that.CANAL_ROOM || (that.room.type === that.SUPPORT_ROOM && !that.assistantView)) {
                            iconColor = 'ffffff';
                            backgroundColor = $('.top-chat-info-data').css('backgroundColor');
                        }

                        if (newMessage.length > 0 && rgb2hex(sendMessageBtn.css('background-color')) === 'ffffff') {

                            tintImage(sendMessageBtn.attr('id'), sendMessageBtn.attr('data-icon'), iconColor);
                            sendMessageBtn.css('background-color', '#' + backgroundColor);

                        } else if (newMessage.length === 0 && rgb2hex(sendMessageBtn.css('background-color')) !== 'ffffff') {

                            tintImage(sendMessageBtn.attr('id'), sendMessageBtn.attr('data-icon'), '000000');
                            sendMessageBtn.css('background-color', '#ffffff');

                        }

                    });

                }
            });

            chatTextarea.autogrow({vertical: true, horizontal: false, postGrowCallback: function () {
                if(currentTextareaHeight !== chatTextarea.outerHeight()){
                    chatMessages.outerHeight(chatMessages.outerHeight() + currentTextareaHeight - chatTextarea.outerHeight());
                    currentTextareaHeight = chatTextarea.outerHeight();
                }
            }});

            $(document).off('click.focusComment').on('click.focusComment', 'body', function(evt) {
                if(focusedComment && evt.target.id !== "chatCommentTextarea"){
                    focusedComment = false;
                    chatTextarea.off('keypress');
                }
            });

            chatMessages.animate({scrollTop: 1}, 150, () => {
                if(chatMessages.scrollTop() > 0){
                    chatMessages.on('scroll', function () {
                        let currentScrollTop = chatMessages.scrollTop();
                        const scrollvaluemax = document.body.scrollHeight - document.body.clientHeight; //scrollvaluemax

                        if(
                            notReadMsgBar.length &&
                            scrollvaluemax > 0 &&
                            window.scrollY > 0 &&
                            scrollvaluemax - window.scrollY <= DEFAULT_BATCH_SIZE
                        ){
                            notReadMsgBar.remove();
                        }

                        if(currentScrollTop === 0 && lastScrollPos > currentScrollTop && loadMorePrevComments){
                            if(that.resMessages.length){

                                api.getChatRoom(function (response) {
                                    if(!response['messages'] || response['messages'].length < DEFAULT_BATCH_SIZE){
                                        loadMorePrevComments = false;
                                    }

                                    that.organizeRoomMessages(response.messages, that.drawPreviousMessages.bind(that));

                                }, that.room.id, that.resMessages[0].id, DEFAULT_BATCH_SIZE);
                            }
                        }

                        lastScrollPos = currentScrollTop;
                    });
                } else if(notReadMsgBar.length) {
                    setTimeout(function () {
                        notReadMsgBar.remove();
                    }, 1500);
                }
            });

            if(notReadMsgBar.length){
                chatMessages.animate({scrollTop: notReadMsgBar.position().top - 50}, 50);
            } else {
                chatMessages.animate({scrollTop: chatMessages.height()}, 50);
            }

            //Button send message (plane icon)
            $('#chat-send-message-icon').off('click').on('click', function() {
                let newMessage = chatTextarea.val().trim();
                let roomId = that.room.id;
                let userworldId = that.room.user ? that.room.user.user_world_id : null;
                let isSupport = that.room.type === that.SUPPORT_ROOM;

                if(newMessage && newMessage.length > 0){
                    chatTextarea.val('');
                    socketRequest.sendMessage(newMessage, that.TEXT_MESSAGE_TYPE, roomId, userworldId, isSupport);
                    var e = $.Event("keydown", { keyCode: 20 });
                    chatTextarea.trigger(e);
                    tintImage(sendMessageBtn.attr('id'), sendMessageBtn.attr('data-icon'), '000000');
                    sendMessageBtn.css('background-color', '#ffffff');
                }
            });

            $(document).off('click.openChatUserDocument').on('click.openChatUserDocument', '.open-chat-user-document-modal', function() {

                let url = $(this).data('url');
                let name = $(this).data('name');
                let type = $(this).data('type');

                switch(type) {
                    case 1:
                        type = 'IMAGE';
                        break;
                    case 2:
                        type = 'VIDEO';
                        break;
                    case 3:
                        type = 'PDF';
                        break;
                    case 4:
                        type = 'DOC';
                        break;
                }

                let template = Handlebars.compile($("#iframeModal").html());

                let context = {
                    color: 'FFFFFF',
                    textColor: '000000',
                    url: url,
                    type: type,
                    documentName: name,
                };

                $("#modalContainer").html(template(context)).modal('show');

                if (type === 'VIDEO') {

                    tintImage($('#document-play-video').attr('id'), $('#document-play-video').attr('data-icon'), '505050');

                    if (world.documentation_autoplay) {
                        $('#videoContainer').find('video')[0].play()
                    }

                    $('#videoContainer').find('video').one('play', function() {
                        $('.document-play-video-icon-container').hide();
                    });

                }

            });

            $(document).off('click.openChatProjectDocument').on('click.openChatProjectDocument', '.open-project-document-details', function() {

                that.inChatRoom = false;
                socketRequest.changeRoomStatus(that.inChatRoom, that.room.id);

                let documentId = $(this).data('document');
                let folderDocument = that.sendedProjectDocuments[documentId].document;
                let folder = that.sendedProjectDocuments[documentId].folder;

                that.openedProjectDocumentMessage = folderDocument;
                that.projectDocumentDetailsOpen = true;

                if (!docSocket) {
                    documentationScreenController.documentationSockets.startNodeConnection();
                }

                if (folderDocument.type === "PATH") {

                    documentationScreenController.documentationPath.getPath(folderDocument.path_id, function(pathData) {
                        folderDocument.pathData = pathData;
                        documentationScreenController.drawDocumentDetails(null, folderDocument, null, folder);
                    });

                    return false;

                }

                documentationScreenController.drawDocumentDetails(null, folderDocument, null, folder);

                $(document).one('click','#documentation-header-close-btn', function() {
                    quizWrapper.addClass('chat-messages-wrapper');
                    socketRequest.changeRoomStatus(that.inChatRoom, that.room.id);
                    baseController.resetStackableOrder();
                    baseController.drawMainMenu(that.tabs.CHAT_TAB);
                    that.projectDocumentDetailsOpen = false;
                    that.openedProjectDocumentMessage = null;
                    that.inChatRoom = true;

                    // Solo repintar la sala si el usuario tiene mensajes nuevos (incluido si ha reenviado el documento abierto a la sala) o si venimos de jugar (Se pierde el html de la sala)
                    if (that.room.user_pointer !== that.room.last_message.id || $('.chatMessages').length === 0) {
                        that.drawIndividualChat(that.room);
                    }

                })

            });

            if (that.room.type === that.INDIVIDUAL_ROOM || that.room.type === that.GROUP_ROOM || that.room.type === that.SUPPORT_ROOM && that.assistantView) {

                $(document).off('click.challengeUser').on('click.challengeUser', '.chat-button-challenge', function() {
                    let transparentButton = $(this).find('.chat-button-transparent');
                    let solidButton = $(this).find('.chat-button-fill');

                    that.toggleVisibleChatTab(transparentButton, solidButton, 'chat-messages-challenge-area');
                });
                $(document).off('click.messagesArea').on('click.messagesArea', '.chat-button-comments', function() {
                    let transparentButton = $(this).find('.chat-button-transparent');
                    let solidButton = $(this).find('.chat-button-fill');

                    that.toggleVisibleChatTab(transparentButton, solidButton, 'chat-messages-content-area');
                });
                $(document).off('click.userProfile').on('click.userProfile', '.chat-button-profile', function() {
                    if(world.profile_customization.show_opponent_profile) {
                        let transparentButton = $(this).find('.chat-button-transparent');
                        let solidButton = $(this).find('.chat-button-fill');

                        that.toggleVisibleChatTab(transparentButton, solidButton, 'chat-messages-profile-area');
                    }
                });
                $(document).off('click.groupProfile').on('click.groupProfile', '.chat-button-profile-group', function() {
                    let transparentButton = $(this).find('.chat-button-transparent');
                    let solidButton = $(this).find('.chat-button-fill');

                    that.toggleVisibleChatTab(transparentButton, solidButton, 'chat-group-users-list');
                })
            }

        }

        let batchSize = this.room.total_unread_messages >= DEFAULT_BATCH_SIZE ?
            this.room.total_unread_messages + 1 : DEFAULT_BATCH_SIZE;

        if(this.room.id && this.room.last_message){

            api.getChatRoom(function (response) {
                that.organizeRoomMessages(response.messages, drawChatRoom, callback);
            }, this.room.id, this.room.last_message.id, batchSize);
        } else {
            drawChatRoom();
            callback ? callback() : null;
        }
    }

    organizeRoomMessages(messages, onCompletedFunction, callback = null) {

        let that = this;
        let userDocumentIds = [];
        let messagesDataDict = {};
        let messagesDataArray = [];

        _.forEach(messages, function(message) {

            if (message.type === that.TEXT_MESSAGE_TYPE) {
                _textMessageType(message, false);
            }

            if (message.type === that.USER_DOCUMENT_TYPE) {
                userDocumentIds.push(message.payload);
                messagesDataDict[message.payload] = message;
            }

            if (message.type === that.PROJECT_DOCUMENT_TYPE) {
                _projectDocumentMessageType(message, false);
            }

        });

        if (this.room.last_message.type === this.TEXT_MESSAGE_TYPE) {
            _textMessageType(this.room.last_message, true);
        }

        if (this.room.last_message.type === this.USER_DOCUMENT_TYPE) {
            userDocumentIds.push(this.room.last_message.payload);
        }

        if (this.room.last_message.type === this.PROJECT_DOCUMENT_TYPE) {
            _projectDocumentMessageType(this.room.last_message, true);
        }

        if (userDocumentIds.length > 0) {
            _userDocumentMessageType(userDocumentIds);
        }

        function _textMessageType(message, lastMessage) {
            if (!lastMessage) {
                message.payload = message.payload;
                messagesDataDict[message.id] = message;
            } else {
                that.room.last_message.payload = message.payload;
            }
        }

        function _userDocumentMessageType(userDocumentIds) {

            api.getChatUserDocuments(userDocumentIds, function(response) {

                let userDocumentsDataObject = response.result;

                for (var key in userDocumentsDataObject) {

                    let userDocumentData = userDocumentsDataObject[key];

                    if (userDocumentData && that.room.last_message.payload === userDocumentData.id) {
                        that.room.last_message.userDocumentData = userDocumentData;
                    } else if (userDocumentData) {
                        messagesDataDict[key].userDocumentData = userDocumentData;
                    }

                }

                for (var key in messagesDataDict) {
                    messagesDataArray.unshift(messagesDataDict[key]);
                }

                onCompletedFunction(messagesDataArray);
                callback ? callback() : null;

            });

        }

        function _projectDocumentMessageType(message, lastMessage) {

            let document = documentationScreenController.getDocument(parseInt(message.payload));
            let parentFolder = null;

            if (document) {
                api.getFolderInfo(document.folder.id, function(response) {
                    parentFolder = response.result;
                    that.sendedProjectDocuments[document.id] = {
                        document: document,
                        folder: parentFolder,
                    }
                });
                document.parentFolderColor = parentFolder.color;
                document.videoOrAudio = document.type === 'VIDEO' || document.type === 'AUDIO';
                DocumentationUtils.formatDocumentParameters(document, parentFolder);
            }

            if (!lastMessage) {
                message.projectDocumentData = document;
                messagesDataDict[message.id] = message;
            } else {
                that.room.last_message.projectDocumentData = document;
            }

        }

        if (userDocumentIds.length === 0) {

            for (var key in messagesDataDict) {
                messagesDataArray.unshift(messagesDataDict[key]);
            }

            onCompletedFunction(messagesDataArray);
            callback ? callback() : null;
        }

    }

    drawChatGroupUsersList(room, friendsCustomization) {
        // Algunas veces llega level otras rank
        room.users.forEach(function (user) {user.level = user.rank});

        let template = Handlebars.compile($("#friendsListFragment").html());
        $("#chat-group-users-list").html(template({
            'world': world,
            'friends': room.users,
            'type': 'friends',
            'friendsCustomization': friendsCustomization
        }));


        $(document).off('click.showUserProfile').on('click.showUserProfile', '.show-user-profile', function (e) {
            let userIndex = $(this).attr('data-room');
            let userWorld = $(this).data('user-world');

            if (userWorld != user.user_world_id) {
                api.getUserProfile(world.token, room.users[userIndex].user_world_id, true);
                $("#chat-group-users-list").hide();
                $("#chat-messages-profile-area").show();
            }
        })
    }

    static adjustChatHeight(){
        let chatMessagesContent = $('#chat-messages').last();

        if (chatMessagesContent.length) {
            let windowHeight = $(window).height();
            let top = chatMessagesContent.offset().top;
            let height = windowHeight - top - $(".chat-send-message-area").height();

            chatMessagesContent.outerHeight(height);
        }
    }

    formatMessages(messages, users = null){
        if(messages.length){
            let that = this;
            let lastTimestamp = messages[0]['send_date'];
            let lastDate = new Date(lastTimestamp*1000);
            let messagesFormatted = {};

            for (let i in messages) {
                let message = messages[i];
                let currentTimestamp = message['send_date'];
                let currentDate = new Date(currentTimestamp*1000);

                if(users)
                    message["user"] = that.getUserMessage(users, message.user_id);

                if(ChatScreenController.sameDay(lastDate, currentDate)){
                    if (!(lastTimestamp in messagesFormatted)) {
                        messagesFormatted[lastTimestamp] = [message];
                    } else {
                        messagesFormatted[lastTimestamp].push(message);
                    }
                } else {
                    lastTimestamp = currentTimestamp;
                    lastDate = currentDate;

                    messagesFormatted[lastTimestamp] = [message];
                }
            }

            return messagesFormatted;
        }

        return [];
    }

    getUserMessage(users, messageUserId){
        let res;
        if(this.room.users)
            users.forEach(function (user) {
                if(user.id === messageUserId) {
                    res = user;
                }
            });
        return res;
    }

    static sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    static formatLocaleDate(currentTimestamp, format){
        let currentLocale = storage.getItem('locale');
        let unixMoment = moment.unix(currentTimestamp);
        let localMoment = moment(unixMoment);

        if(currentLocale){
            localMoment.locale(currentLocale);
        }

        return localMoment.format(format);
    }

    toggleVisibleChatTab(transparentButton, solidButton, areaId){
        if(transparentButton.is(':visible')){
            let chatAreas = ['chat-messages-content-area', 'chat-messages-profile-area', 'chat-messages-challenge-area', 'chat-group-users-list'];
            let that = this;

            if(!this.inChatRoom){
                $('.stackable').last().remove();
            }

            if(areaId !== 'chat-messages-content-area' && this.inChatRoom){
                this.inChatRoom = false;
                if (this.room.id) {
                    socketRequest.changeRoomStatus(this.inChatRoom, this.room.id);
                }
            }

            $('.top-chat-action-table .chat-button-transparent').show();
            $('.top-chat-action-table .chat-button-fill').hide();
            solidButton.show();
            transparentButton.hide();

            switch(areaId){
                case 'chat-messages-content-area':
                    $('#chat-messages-content-area').empty();
                    this.roomSelectedOption = this.MESSAGES_ROOM_OPTION;
                    this.drawIndividualChat(this.room);
                    break;

                case 'chat-messages-profile-area':
                    this.roomSelectedOption = this.USER_PROFILE_ROOM_OPTION;
                    api.getUserProfile(world.token, this.room.user.user_world_id, true);
                    break;

                case 'chat-messages-challenge-area':
                    this.roomSelectedOption = this.CHALLENGE_ROOM_OPTION;
                    api.getPendingChallenges(world.token, true, true);
                    break;
                case 'chat-group-users-list':
                    this.roomSelectedOption = this.GROUP_PROFILE_ROOM_OPTION;
                    that.drawChatGroupUsersList(that.room, baseController.userCustomization());
                    break;
            }

            for(let i in chatAreas){
                if(chatAreas[i] === areaId){
                    $('#' + chatAreas[i]).show();
                } else {
                    $('#' + chatAreas[i]).hide();
                }
            }

            rankingScreenController.adaptDivToContentRankingUsersList();
        }
    }

    drawPreviousMessages(addMessages){
        let that = this;
        let currentFirstMsg = this.resMessages[0];
        let lastTimestamp = currentFirstMsg.receive_date;
        let lastUserWorld = currentFirstMsg.user_world_id;
        let lastDate = new Date(lastTimestamp*1000);
        let newMessageHtml = '';
        let currentLocale = storage.getItem('locale');
        let actualDate = new Date();
        let firstMessage = $('.chat-message-row').first();
        let chatMessages = $('#chat-messages');
        let roomHeaderColor = $('.top-chat-info-data').css('background-color');
        let roomTextColor = $('.top-chat-info-back-btn').css('color');

        // Se pintan de abajo a arriba por loque hay que ordenarlos descendentemente
        addMessages.sort(that.sortDescMessages);

        for(let i in addMessages){
            let currentAdd = addMessages[i];
            let currentTimestamp = currentAdd.receive_date;
            let currentDate = new Date(currentTimestamp*1000);
            let unixMoment = moment.unix(currentTimestamp);
            let localMoment = moment(unixMoment);
            let dateFormat = 'DD MMMM YYYY';
            let currentUser = _.filter(this.room.users, function (user) { return user.id === currentAdd.user_id})[0];

            if(currentLocale){
                localMoment.locale(currentLocale);
            }

            this.resMessages.unshift(currentAdd);

            if(actualDate.getFullYear() === currentDate.getFullYear()){
                dateFormat = 'DD MMMM';
            }

            let dateFormatted = ChatScreenController.formatLocaleDate(currentTimestamp, dateFormat);
            let prevHourFormatted = ChatScreenController.formatLocaleDate(lastTimestamp, 'HH:mm');
            let hourFormatted = ChatScreenController.formatLocaleDate(currentTimestamp, 'HH:mm');
            let firstListElem = chatMessages.children().first();
            let messagePos = user.user_world_id !== currentAdd.user_world_id ? 'left' : 'right';

            if(prevHourFormatted === hourFormatted && lastUserWorld === currentAdd.user_world_id) {
                chatMessages.find('.message-time').first().remove();
                if (messagePos === 'left') {
                    chatMessages.find('.chat-group-user-image').first().css('display', 'none');
                }
            }

            let compiledHTMLMessageTemplate = Handlebars.compile($('#roomMessageFragment').html());

            $('.tintedCanvas.doctype-icon').each(function() {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), '000000');
            });

            $('.tintedCanvas.project-document-icon').each(function() {
                tintImage($(this).attr('id'), $(this).attr('data-icon'), '000000');
            });

            if (ChatScreenController.sameDay(lastDate, currentDate) && firstListElem.hasClass('date-messages-badge')) {
                firstListElem.after(compiledHTMLMessageTemplate(that.chat.createHTMLMessage(true, false, currentUser, currentAdd)));
                firstListElem.after(newMessageHtml);
            } else {
                newMessageHtml = compiledHTMLMessageTemplate(that.chat.createHTMLMessage(true, true, currentUser, currentAdd));
                firstListElem.before(newMessageHtml);
            }

            let doctypeName = $('.message-user-document-doc-name');
            let projectDocumentName = $('.project-document-message-name');
            let documentNameHeight = 30;

            if ($(window).width() <= 420) {
                documentNameHeight = 20;
            }

            doctypeName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true,
            });

            projectDocumentName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true
            });

            currentFirstMsg = currentAdd;
            lastTimestamp = currentTimestamp;
            lastDate = currentDate;
            newMessageHtml = '';
            lastUserWorld = currentAdd.user_world_id;
        }

        chatMessages.animate({scrollTop: firstMessage.position().top - 50}, 50);
    }

    sortAscMessages(a,b) {
        if ((a.receive_date < b.receive_date) || (a.receive_date === b.receive_date && a.id < b.id))
            return -1;
        if ((a.receive_date > b.receive_date) || (a.receive_date === b.receive_date && a.id > b.id))
            return 1;

        return 0;
    }

    sortDescMessages(a,b) {
        if ((a.receive_date > b.receive_date) || (a.receive_date === b.receive_date && a.id > b.id))
            return -1;
        if ((a.receive_date < b.receive_date) || (a.receive_date === b.receive_date && a.id < b.id))
            return 1;

        return 0;
    }

    drawNewHtmlMessage(lastMessage, newMessageObj, messageUserWorld, messagePos){
        let newMessageHtml = '';
        let lastTimestamp = null;
        let lastDate = null;
        let prevHourFormatted = null;

        if(lastMessage){
            lastTimestamp = lastMessage.receive_date;
            if(typeof lastTimestamp !== 'number'){
                lastTimestamp = parseInt(lastTimestamp);
            }
            lastDate = new Date(lastTimestamp*1000);
            prevHourFormatted = ChatScreenController.formatLocaleDate(lastTimestamp, 'HH:mm');
        }

        let currentTimestamp = newMessageObj.send_date;
        let currentDate = new Date(currentTimestamp*1000);
        let dateFormatted = ChatScreenController.formatLocaleDate(currentTimestamp, 'DD MMMM');
        let hourFormatted = ChatScreenController.formatLocaleDate(currentTimestamp, 'HH:mm');
        let showMessageTime = false;
        let showMessageDate = false;
        let lastSendUserData = null;

        if (!lastMessage || !ChatScreenController.sameDay(lastDate, currentDate)) {
            showMessageDate = true
        }

        if(!lastMessage || lastMessage.user_world_id !== messageUserWorld || prevHourFormatted !== hourFormatted) {

            showMessageTime = true;

            if (this.room.type === this.GROUP_ROOM && this.room.last_message.user_world_id !== user.user_world_id) {
                lastSendUserData = this.getUserMessage(this.room.users, this.room.last_message.user_id);
            }

        }

        newMessageHtml = Handlebars.compile($('#roomMessageFragment').html());
        $('#chat-messages').append(newMessageHtml(this.chat.createHTMLMessage(showMessageTime, showMessageDate, lastSendUserData, newMessageObj)));

        let documentNameHeight = 30;

        if ($(window).width() <= 420) {
            documentNameHeight = 20;
        }

        if (newMessageObj.type === this.USER_DOCUMENT_TYPE) {
            let doctypeIconId = $('#doctype-icon-' + newMessageObj.id);
            let doctypeName = $('.message-user-document-doc-name');

            tintImage(doctypeIconId.attr('id'), doctypeIconId.attr('data-icon'), '000000');
            doctypeName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true,
            });

        }

        if (newMessageObj.type === this.PROJECT_DOCUMENT_TYPE) {
            let projectDocumentName = $('.project-document-message-name');
            projectDocumentName.dotdotdot({
                height: documentNameHeight,
                wrap: 'letter',
                watch: true
            });
        }

        if (newMessageObj.type === this.PROJECT_DOCUMENT_TYPE) {
            let iconId = $('#project-document-icon-' + newMessageObj.id);
            tintImage(iconId.attr('id'), iconId.attr('data-icon'), '000000');

        }


    }

    drawChatUnreadMessages() {
        let chatTab = $('.chatTab');
        let unreadMessagesData = $.parseJSON(storage.getItem('chat_unread_messages'));
        let unreadMessages = unreadMessagesData ? unreadMessagesData.unreadMessages : 0;

        if(unreadMessages > 0) {
            $('.chat-list-not-read-messages').text(unreadMessages);
            if(unreadMessages > 10) {
                $('.chat-list-not-read-messages').closest('li').css('padding-right', 25);
            }
        } else {
            chatTab.find('.chat-list-not-read-messages').remove();
        }
    }

    saveRooms(rooms = [], resetSavedRooms = false) {

        let that = this;

        if (resetSavedRooms) {

            this.allRooms = {rooms: [], roomsIds: []};
            this.individualRooms = {rooms: [], roomsIds: []};
            this.groupRooms = {rooms: [], roomsIds: []};
            this.canalRooms = {rooms: [], roomsIds: []};
            this.supportRooms = {rooms: [], roomsIds: []};

        }

        _.forEach(rooms, function(room) {

            switch(room.type) {

                case that.INDIVIDUAL_ROOM:
                    that.individualRooms.rooms.push(room);
                    that.individualRooms.roomsIds.push(room.id);
                    break;

                case that.GROUP_ROOM:
                    that.groupRooms.rooms.push(room);
                    that.groupRooms.roomsIds.push(room.id);
                    break;

                case that.CANAL_ROOM:
                    that.canalRooms.rooms.push(room);
                    that.canalRooms.roomsIds.push(room.id);
                    break;

                case that.SUPPORT_ROOM:
                    that.supportRooms.rooms.push(room);
                    that.supportRooms.roomsIds.push(room.id);
                    break;

            }

            that.allRooms.rooms.push(room);
            that.allRooms.roomsIds.push(room.id);

        });

    }

    updateRoom(updatedRoom) {

        switch(updatedRoom.type) {

            case this.INDIVIDUAL_ROOM:
                let individualRoomIndex = this.individualRooms.roomsIds.indexOf(updatedRoom.last_message.room_id);
                this.individualRooms.rooms[individualRoomIndex] = updatedRoom;
                break;

            case this.GROUP_ROOM:
                let groupRoomIndex = this.groupRooms.roomsIds.indexOf(updatedRoom.last_message.room_id);
                this.groupRooms.rooms[groupRoomIndex] = updatedRoom;
                break;

            case this.CANAL_ROOM:
                let canalRoomIndex = this.canalRooms.roomsIds.indexOf(updatedRoom.last_message.room_id);
                this.canalRooms.rooms[canalRoomIndex] = updatedRoom;
                break;

            case this.SUPPORT_ROOM:
                let supportRoomIndex = this.supportRooms.roomsIds.indexOf(updatedRoom.last_message.room_id);
                this.supportRooms.rooms[supportRoomIndex] = updatedRoom;
                break;

        }

        let allRoomsIndex = this.allRooms.roomsIds.indexOf(updatedRoom.last_message.room_id);
        this.allRooms.rooms[allRoomsIndex] = updatedRoom;

    }

    addRoomToList(updatedRoom) {

        let that = this;
        let addedRoom = false;
        let isSearchResult = $('.chat-search-back-btn').length && $('.chat-search-back-btn').css('display') === 'block';

        // Buscar las salas existentes para anyadirlas/actualizarlas sobre las que esta viendo el usuario (that.rooms)
        _.forEach(that.rooms, function(room, index) {

             if (updatedRoom.type === room.type && (updatedRoom.type === that.INDIVIDUAL_ROOM && !that.assistantView || updatedRoom.type === that.SUPPORT_ROOM && that.assistantView)) {
                if (room.user.user_world_id === updatedRoom.user.user_world_id) {
                    that.rooms[index] = updatedRoom;
                    addedRoom = true;
                    return;
                }
            } else if (room.id === updatedRoom.id) {
                that.rooms[index] = updatedRoom;
                addedRoom = true;
                return;
            }

        });

        // Si la sala no se ha encontrado creada y el usuario se encuentra en la vista de chats (no en el buscador de amigos) anyadir/actualizar sala
        if (updatedRoom.type === this.INDIVIDUAL_ROOM && !this.assistantView || updatedRoom.type === this.SUPPORT_ROOM && this.assistantView) {
            if (!addedRoom && !isSearchResult) {;
                that.rooms.length === 0  ? that.rooms.push(updatedRoom) : that.rooms.unshift(updatedRoom);
            }
        }

    }

    receiverInSameRoom(newMessage, roomType) {

        if (!this.inChatRoom) {
            return false;
        }
        if (this.room.id) {
            return this.room.id === newMessage.room_id;
        }
        if (this.room.type === roomType) {

            if (this.room.type === this.INDIVIDUAL_ROOM || this.room.type === this.SUPPORT_ROOM && this.assistantView) {
                return this.room.user.user_world_id === newMessage.user_world_id;
            }

            if (this.room.type === this.SUPPORT_ROOM && !this.assistantView) {
                return newMessage.user_worlds_ids.indexOf(user.user_world_id) >= 0;
            }

        }

        return false;
    }

    updateTransmitterRoom(messageData) {

        if (user.user_world_id === messageData.user_world_id) {

            let newMessage = this.chat.createMessage(messageData);
            let previousMessage = this.room.last_message;
            let createdRoom = _.find(this.allRooms.rooms, function(room) {
                return room.id === messageData.message.room_id;
            });
            let chatMessagesSelector = $('#chat-messages');
            let chatMessagesHeight = chatMessagesSelector.length > 0 ? chatMessagesSelector[0].scrollHeight : 0;

            if (this.modalShareChatDocument.modalOpen) {

                this.sendProjectDocumentRoomData.id = newMessage.room_id;
                this.sendProjectDocumentRoomData.last_message = newMessage;
                this.sendProjectDocumentRoomData.type = messageData.message.type_room;

                createdRoom ? this.updateRoom(this.sendProjectDocumentRoomData) : this.saveRooms([this.sendProjectDocumentRoomData], false);

                let selectedRoomId = this.sendProjectDocumentRoomData.id;
                this.sendedProjectDocumentRooms[selectedRoomId] = true;
                this.addRoomToList(this.sendProjectDocumentRoomData);
                this.drawChatList(this.rooms, $('.chat-search-back-btn').is(':visible'));

            } else {

                this.resMessages.push(newMessage);
                this.room.id = newMessage.room_id;
                this.room.last_message = newMessage;
                this.room.total_unread_messages = 0;
                this.room.user_pointer = newMessage.id;

                // Se dibuja el mennsaje en la sala, se guarda/actualiza el nuevo estado de la sala y se anyade a la lista de salas que esta viendo actualmente
                this.drawNewHtmlMessage(previousMessage, newMessage, newMessage.user_world_id, 'right');
                createdRoom ? this.updateRoom(this.room) : this.saveRooms([this.room], false);
                this.addRoomToList(this.room);

                chatMessagesSelector.scrollTop(chatMessagesHeight);
            }

        }

    }

    updateReceiverRoom(messageData) {

        if (user.user_world_id !== messageData.user_world_id) {
            let that = this;
            let newMessage = this.chat.createMessage(messageData);
            let previousMessage = this.room.last_message;
            let createdRoom = _.find(this.allRooms.rooms, function (room) {
                return room.id === messageData.message.room_id;
            });
            let messageRoomType = createdRoom ? createdRoom.type : messageData.room.type;
            let newRoom = {};
            let chatMessagesSelector = $('#chat-messages');
            let chatMessagesHeight = chatMessagesSelector.length > 0 ? chatMessagesSelector[0].scrollHeight : 0;

            socketRequest.notifyMessageReceived(newMessage.id);
            this.updateChatNotifications('ADD', newMessage, messageRoomType, 1);

            // Si el usuario receptor se encuentra en la misma sala que el usuario emisor
            if (this.receiverInSameRoom(newMessage, messageRoomType)) {

                // Si la sala no existia ahora ya tiene id por lo que se debe modificar el estado de la misma a inChatRoom True para el receptor cuando recibe el mensaje
                if (!this.room.id) {
                    this.inChatRoom = true;
                    socketRequest.changeRoomStatus(this.inChatRoom, newMessage.room_id);
                }

                // Se actualiza la sala en la que se encuentra el receptor del mensaje
                this.resMessages.push(newMessage);
                this.room.id = newMessage.room_id;
                this.room.last_message = newMessage;
                this.room.total_unread_messages = 0;
                this.room.user_pointer = newMessage.id;

                // Se dibuja el mennsaje en la sala, se guarda/actualiza el nuevo estado de la sala y se anyade a la lista de salas que esta viendo actualmente
                this.drawNewHtmlMessage(previousMessage, newMessage, newMessage.user_world_id, 'left');
                createdRoom ? this.updateRoom(this.room) : this.saveRooms([this.room], false);
                this.addRoomToList(this.room);

            // Si el usuario receptor no se encuentra en la misma sala que el usuario emisor pero esta existe
            } else if (createdRoom) {

                // Actualizar la sala existente del usuario receptor
                createdRoom.total_unread_messages += 1;
                createdRoom.other_user_pointer = newMessage.id;
                createdRoom.last_message = newMessage;

                // Actualizar la sala en la lista de salas creadas y las que esta viendo el usuario en el momento de recibir el mensaje (this.rooms)
                this.updateRoom(createdRoom);
                this.addRoomToList(createdRoom);

                // Refrescar los cambios siempre que el usuario se encuentre en la pestanya chat y no este en ninguna sala
                if (baseController.selectedTabId === this.tabs.CHAT_TAB && !this.inChatRoom && !this.projectDocumentDetailsOpen) {
                    this.drawChatList(this.rooms, $('.chat-search-back-btn').is(':visible'));
                }

                // Se debe refrescar tambien los cambios si tenemos el modal abierto en la documentacion para compartir un documento
                if (this.modalShareChatDocument.modalOpen) {
                    this.drawChatList(this.rooms, $('.chat-search-back-btn').is(':visible'));
                }

                // Pintar bolita roja de mensajes nuevos si esta en la misma sala que el usuario emisor pero esta en otra opcion de la sala (por ejemplo viendo el perfil)
                if (this.roomSelectedOption && this.roomSelectedOption !== this.MESSAGES_ROOM_OPTION) {
                    if (this.room.id === newMessage.room_id) {
                        $('.red-dot-pending-messages').show();
                    }
                }

            // Si el usuario receptor no se encuentra en la misma sala que el emisor y no existe la sala
            } else {

                // Se crea la sala, se guarda y se actualiza la lista de salas que esta viendo el usuario actualmente (this.rooms)
                newRoom = this.chat.createNewRoom(messageData.user, newMessage, messageData.room.type);

                this.saveRooms([newRoom], false);
                this.addRoomToList(newRoom);

                // Refrescar los cambios siempre que el usuario se encuentre en la pestanya chat y no este en ninguna sala
                if (baseController.selectedTabId === this.tabs.CHAT_TAB && !this.inChatRoom && !this.projectDocumentDetailsOpen) {
                    this.drawChatList(this.rooms, $('.chat-search-back-btn').is(':visible'));
                }

                // Se debe refrescar tambien los cambios si tenemos el modal abierto en la documentacion para compartir un documento
                if (this.modalShareChatDocument.modalOpen) {
                    this.drawChatList(this.rooms, $('.chat-search-back-btn').is(':visible'));
                }

                // Pintar bolita roja de mensajes nuevos si esta en la misma sala que el usuario emisor pero esta en otra opcion de la sala (por ejemplo viendo el perfil)
                if (this.roomSelectedOption && this.roomSelectedOption !== this.MESSAGES_ROOM_OPTION) {
                    if (this.room.id === newMessage.room_id || !this.room.id && this.room.user.user_world_id === messageData.user_world_id) {
                        $('.red-dot-pending-messages').show();
                        this.room = newRoom;
                    }

                }

            }

            chatMessagesSelector.scrollTop(chatMessagesHeight);
        }
    }

    updateChatNotifications(operation, newMessage, roomType, unreadMessagesNumber) {

        let unreadMessagesData = $.parseJSON(storage.getItem('chat_unread_messages'));
        let unreadMessages = unreadMessagesData.unreadMessages;
        let unreadUserMessages = unreadMessagesData.unreadUserMessages;
        let unreadSupportMessages = unreadMessagesData.unreadSupportMessages;

        if (operation === 'ADD' && newMessage) {
            if (!this.receiverInSameRoom(newMessage, roomType)) {
                unreadMessages += unreadMessagesNumber;
                roomType === this.SUPPORT_ROOM ? unreadSupportMessages += unreadMessagesNumber : unreadUserMessages += unreadMessagesNumber;
            }
        }

        if (operation === 'DEDUCT') {
            unreadMessages -= unreadMessagesNumber;
            roomType === this.SUPPORT_ROOM ? unreadSupportMessages -= unreadMessagesNumber : unreadUserMessages -= unreadMessagesNumber;
        }

        unreadMessagesData = {
            unreadMessages: unreadMessages,
            unreadUserMessages: unreadUserMessages,
            unreadSupportMessages: unreadSupportMessages
        }

        storage.setItem('chat_unread_messages', JSON.stringify(unreadMessagesData))
        this.drawChatUnreadMessages();

    }

    // Se ejecuta para el emisor cuando el receptor entra en la sala donde tenia un mensaje del emisor
    updateRoomMessagesStatus(roomData) {

        if (roomData.user_world_id !== user.user_world_id) {

            // Si el emisor se encuentra dentro de la sala se le pinta el check de mensaje visto
            if (this.inChatRoom && this.room.id === roomData.room_id) {

                this.room.other_user_pointer = roomData.other_user_pointer;

                $('.chat-message-row.right-message-row .message-time').each(function () {
                    if ($(this).length && !$(this).find('.fa.fa-check').length) {

                        let checkColor = $('.top-chat-info-data').css('background-color');
                        let messageTimeColor = $('.top-chat-info-data').css('background-color');

                        $(this).css('color', messageTimeColor);
                        $(this).append(' <i class="fa fa-check" style="color: ' + checkColor + ';"></i>');
                    }
                });

            // Si el emisor no se encuentra en sala o no en la misma que el receptor se actualiza la lista de chats (this.rooms) para marcar su ultimo mensaje como visto
            } else {

                let that = this;

                _.forEach(this.allRooms.rooms, function(room, index) {

                    if (room.id === roomData.room_id) {

                        that.allRooms.rooms[index].other_user_pointer = roomData.other_user_pointer;

                        if (!that.inChatRoom && !that.projectDocumentDetailsOpen && baseController.selectedTabId === that.tabs.CHAT_TAB) {
                            that.drawChatList(that.rooms, $('.chat-search-back-btn').is(':visible'));
                        }

                    }

                });

            }
        }

    }

    supportChatManagement() {

        let that = this;

        if (user.user_chat_is_assistant) {

            let chatSupportBannerHeight = $('.chat-support-canvas').height();
            let textSelector = $('.chat-support-change-view-text');
            let iconSelector = $('.chat-support-icon.assistant-view');

            // Si hay almenos una sala anyadir un margen inferior al canvas de la lista de chats para que no quede tapado por el canvas de soporte
            if ($('#chat-list').height() > 0) {
                $('#chat-list').css('height', $('#chat-list').height() + chatSupportBannerHeight);
            }


            if (!that.assistantView) {

                textSelector.text(Translator.trans('TR_CAMBIAR_A_VISTA_AGENTE'));
                iconSelector.css('background-image', 'url(' + world.theme.support_avatar + ')');

            } else {

                textSelector.text(Translator.trans('TR_CAMBIAR_A_VISTA_USUARIO'));
                iconSelector.css('background-image', 'url(' + user.icon + ')');

            }

            $(document).off('click.changeAssistantView').on('click.changeAssistantView', '.chat-support-canvas', function() {
                that.assistantView = !that.assistantView;
                let supportRooms = that.supportRooms.rooms;
                let otherRooms = that.individualRooms.rooms.concat(that.groupRooms.rooms, that.canalRooms.rooms);
                let roomsToShow = that.assistantView ? supportRooms : otherRooms;
                that.drawChatList(roomsToShow, false);
            });

        } else {
            $(document).off('click.openSupportChatRoom').on('click.openSupportChatRoom', '.chat-support-icon', function() {

                if (that.modalShareChatDocument.modalOpen) {

                    let room = that.supportRooms.rooms.length > 0 ? that.supportRooms.rooms[0] : null;

                    if (!room || !room.projectDocumentSended) {

                        let messagePayload = that.modalShareChatDocument.documentId;
                        let messageType = that.PROJECT_DOCUMENT_TYPE;
                        let messageRoomId =  that.supportRooms.rooms.length > 0 ? that.supportRooms.rooms[0].id : null;
                        let messageUserId = user.user_world_id;
                        let messageToSupport = true;
                        const documentTitle = documentationScreenController.getDocument(that.modalShareChatDocument.documentId).name;

                        that.sendProjectDocumentRoomData = room ? room : that.chat.getNewEmptyRoom(user, that.SUPPORT_ROOM);

                        const swalOptions = {
                            title: Translator.trans("TR_COMPARTIR_CON"),
                            text: sprintf(Translator.trans("TR_VAS_A_COMPARTIR"), documentTitle, world.theme.support_name),
                            showConfirmButton: true,
                            showCancelButton: true,
                            closeOnConfirm: false,
                            closeOnCancel: false,
                            confirmButtonText: Translator.trans("TR_ENVIAR").toUpperCase(),
                            confirmButtonColor: "#85DD01",
                            cancelButtonText: Translator.trans("TR_CANCELAR").toUpperCase(),
                            allowEscapeKey: false
                        }

                        swal(swalOptions, function(send) {

                            if (send) {
                                socketRequest.sendMessage(messagePayload, messageType, messageRoomId, messageUserId, messageToSupport);
                            }

                            swal.close();

                        });

                    }

                } else {
                    let createdSupportChatRoom = that.supportRooms.rooms.length > 0 ? that.supportRooms.rooms[0] : null;
                    let roomToShow = createdSupportChatRoom ? createdSupportChatRoom : that.chat.getNewEmptyRoom(user, that.SUPPORT_ROOM);
                    that.drawIndividualChat(roomToShow);
                }

            });

        }

    }

    updateRoomMessageData(messageData) {

        const that = this;
        let pendingRequestMessagesData = 0;
        let document = null;
        let parentFolder = null;

        if (messageData.message.type === this.USER_DOCUMENT_TYPE && this.inChatRoom) {

            pendingRequestMessagesData += 1;

            api.getChatUserDocument(parseInt(messageData.message.payload), function (response) {

                pendingRequestMessagesData -= 1;

                messageData.message.userDocumentData = response.result;

                if (pendingRequestMessagesData === 0) {
                    chatScreenController.updateTransmitterRoom(messageData);
                    chatScreenController.updateReceiverRoom(messageData);
                }

            });

        }

        if (messageData.message.type === this.PROJECT_DOCUMENT_TYPE && this.inChatRoom) {

            document = documentationScreenController.getDocument(parseInt(messageData.message.payload));

            if (document) {
                api.getFolderInfo(document.folder.id, function(response) {
                    parentFolder = response.result;
                    that.sendedProjectDocuments[document.id] = {
                        document: document,
                        folder: parentFolder,
                    }
                });
                document.parentFolderColor = parentFolder.color;
                document.videoOrAudio = document.type === 'VIDEO' || document.type === 'AUDIO';
                DocumentationUtils.formatDocumentParameters(document, parentFolder);
                messageData.message.projectDocumentData = document;

            }

        }

        if (pendingRequestMessagesData === 0) {
            this.updateTransmitterRoom(messageData);
            this.updateReceiverRoom(messageData);
        }

    }

}